export const TRACKING_ID = 'UA-223253835-1'
